import { useState } from "react"
import { useDialog } from "../../hooks/useDialog"
import { venueNames } from "../../utils/bookings-data"

export const RectifyPayment = ({data}) => {

    const [formData, setFormData] = useState({
        method: data?.payment.method,
        amount: data?.payment.amount,
        type: data?.payment.type,
        venueId: data?.payment.venueId,
        reason: "",
    })

    const dialog = useDialog()

    const handleInputChange = (event) => {

        let {target: {value, name}} = event

        const numbers = ['amount']
        if (numbers.includes(name)) value = Number(value)

        setFormData(prev => ({...prev, [name]: value}))
    }

    const handleSave = async () => {

        if (!formData.reason) {
            alert("Debe incluir el motivo de la rectificacion")
            return
        }

        const cashReconciliationId = data.cashReconciliationId
        const paymentId = data.payment.id

        if (!cashReconciliationId || !paymentId)
            throw new Error('insuficient parameters')

        dialog.close()
        
        data.onRectified({
            id: paymentId,
            cashReconciliationId,
            ...formData,
        })
    }

    return (
        <>
        <h5>Rectificar Pago</h5>
        <form>
            <div className="input_group">
                <div>
                    <p className="label">Tipo</p>
                    <select className="form-control" name="type" value={formData.type} onChange={handleInputChange}>
                        <option value="total">Total</option>
                        <option value="partial">Parcial</option>
                    </select>
                </div>
                <div>
                    <p className="label">Método</p>
                    <select className="form-control" name="method" value={formData.method} onChange={handleInputChange}>
                        <option value="cash">Efectivo</option>
                        <option value="creditcard">Tarjeta</option>
                    </select>
                </div>
                <div>
                    <p className="label">Tablao</p>
                    <select className="form-control" name="venueId" value={formData.venueId} onChange={handleInputChange}>
                        <option value={1}>{venueNames[1]}</option>
                        <option value={2}>{venueNames[2]}</option>
                    </select>
                </div>
                <div>
                    <p className="label">Cantidad</p>
                    <input type="number" name="amount" className="form-control" value={formData.amount} onChange={handleInputChange}/>
                </div>
            </div>
            <div className="input_group rectify-reason">
                <div>
                    <textarea name="reason" onChange={handleInputChange} value={formData.reason} className="form-control" placeholder="Motivo"/>
                </div>
            </div>
            <div className="actions-container">
                <button type="button" className="btn" onClick={() => dialog.close()}>
                    Cancelar
                </button>
                <button type="button" className="btn rmb-btn-primary" onClick={handleSave}>
                    Rectificar
                </button>
            </div>
        </form>
        </>
    )
}